import { CognitoUser, UserData } from 'amazon-cognito-identity-js';

export function shouldShowMFASetup(mfaEnabled: boolean, isAgentUser: boolean, agencyMfaEnabled: boolean): boolean {
  // Agent MFA is controlled per-agency, not by the shared domain-level staffMFAEnabled flag
  if (isAgentUser) {
    return agencyMfaEnabled;
  }

  return mfaEnabled;
}

export async function userMFAEnabled(user: CognitoUser): Promise<boolean> {
  // Get user data to check if MFA is enabled. If there's an error (e.g. network issue),
  // assume MFA is not enabled so the user can still log in
  try {
    const userData = await new Promise<UserData>((resolve, reject) => {
      user.getUserData((err, data) => {
        if (err) {
          reject(err);
          return;
        }
        if (!data) {
          reject(new Error('No user data returned'));
          return;
        }
        resolve(data);
      });
    });
    return (userData?.UserMFASettingList?.length ?? 0) > 0;
  } catch {
    return false;
  }
}
